import { render, staticRenderFns } from "./GAccountPersonInCharge.vue?vue&type=template&id=0686dfa9&scoped=true&"
import script from "./GAccountPersonInCharge.vue?vue&type=script&lang=ts&"
export * from "./GAccountPersonInCharge.vue?vue&type=script&lang=ts&"
import style0 from "./GAccountPersonInCharge.vue?vue&type=style&index=0&id=0686dfa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686dfa9",
  null
  
)

export default component.exports